import type { ReactElement } from 'react';
import { createPortal } from 'react-dom';
import { getPortalParentSelector } from '@balance-web/core';

type Props = {
  children: ReactElement;
};

export const Portal = ({ children }: Props) => {
  if (typeof document === 'undefined') {
    return null;
  }
  const target = document.querySelector(getPortalParentSelector());
  if (!target) {
    return null;
  }

  return createPortal(children, target);
};
